module.exports = __webpack_public_path__ + "img/weekly-deliveries.3dc9c655.png";